export const GILDED_TOKENS_CATALOGUE_MD = 'reports/GILDED_TOKENS_CATALOGUE.md';
export const REDUCED_MOTION_101_GUIDE_MD = 'reports/REDUCED_MOTION_101_GUIDE.md';
export const REDUCED_MOTION_100_COMPLETE_MD = 'reports/REDUCED_MOTION_100_COMPLETE.md';
